import parentRoutes from './parent';
import staffRoutes from './staff';

export default [...parentRoutes, ...staffRoutes];
